import React from "react"
import text from "../../../assets/images/sexologa-text-2.svg"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import IconHeart from "../../../assets/images/icon-heart.svg"

import "./consulting-item.scss"

const ConsultingItem = props => {
  
  return (
    <div
      className={`f-consulting-item ${
        props.title === "Sexóloga" ? "bold" : ""
      }`}
    >
      <div className={props.title === "Bullying" ? "Loving" : ""}>
        <img
          className="f-img-item-consulting"
          loading="lazy"
          src={props.imgUrl}
          alt={props.alt}
        />
      </div>
      <div className="f-right-container-consulting">
        <h3
          className={`f-title-item-consulting ${
            props.title === "Bullying" ? "bold" : ""
          }`}
        >
          {props.title}
        </h3>
        {props.title === "Bullying" ? (
          <div className="f-description-item-consulting">
            {documentToReactComponents(props.description)}
          </div>
        ) : (
          <p
            className="f-description-item-consulting"
            dangerouslySetInnerHTML={{ __html: props.description }}
          ></p>
        )}
        {props.title === "Sexóloga" && (
          <img
            className="f-img-item-text"
            loading="lazy"
            src={text}
            alt="tu consulta es completamente privada."
          />
        )}
      </div>
    </div>
  )
}

export default ConsultingItem
